// Full-screen "switching account" overlay. Mounted via plain DOM — not
// React — so it paints on the same frame as the click, before the hard
// reload / navigation tears React down. Without it, the current page
// stays fully visible during the ~1 s gap between click and the new
// page's first paint, and the user thinks the click missed.
export function showSwitchOverlay() {
  if (typeof document === 'undefined') return;
  if (document.getElementById('_acctSwitchOverlay')) return;

  if (!document.getElementById('_acctSwitchSpinKF')) {
    const style = document.createElement('style');
    style.id = '_acctSwitchSpinKF';
    style.textContent = '@keyframes _acctSwitchSpin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }

  const overlay = document.createElement('div');
  overlay.id = '_acctSwitchOverlay';
  overlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:10000',
    'background:var(--mantine-color-body, #fff)',
    'opacity:0.9',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'pointer-events:all',
  ].join(';');

  const spinner = document.createElement('div');
  spinner.style.cssText = [
    'width:36px',
    'height:36px',
    'border:3px solid rgba(120,120,120,0.25)',
    'border-top-color:var(--mantine-color-indigo-filled, #4c6ef5)',
    'border-radius:50%',
    'animation:_acctSwitchSpin 0.8s linear infinite',
  ].join(';');
  overlay.appendChild(spinner);

  document.body.appendChild(overlay);
}
